import React, { useState } from 'react';
import { xs_isMobile } from '../..';
import { getLabel } from '../../InitData';
import { BetslipContext } from '../betslip/BetslipConf';

function ReloadTicketButton(props) {
    const betslipContext = React.useContext(BetslipContext);
    const [success, setSuccess] = useState(false);
    const isMobile = xs_isMobile;

    function handleClick() {
    	let invokeInParent = false;
    	try {
    		invokeInParent = !isMobile && window.opener && window.opener.reloadTicket;    		
    	}
    	catch(e){
    		console.log('WARNING: Parent dom is unavailable.')
            console.error(e);
            
            //If cross origin frame error occurs, send a post message
            try {
                window.opener.postMessage({
                type: 'reloadTicket',
                payload: {'ticketId':props.id}
            },"*");

            }catch(err) {
                console.log(err);
            }

    	}
    	if(invokeInParent){
    		// if desktop, the betslip is in the parent window because 
    		// we are into a popup opened by it. I can master the parent dom 
    		// because we are sharing the same domain with it.
    		window.opener.reloadTicket(props.id);
    	}
    	else{
            betslipContext.reloadTicket(props.id);
            setSuccess(true);
            setTimeout(() => setSuccess(false), 1000);
    	}

    }

    return (
        <>
            {success ?
                <span className="checkbet-button checkbet-success" onClick={handleClick}>{getLabel('mybets.added_to_cart')} &#10003;</span>
                :
                <span className="checkbet-button" onClick={handleClick}>{getLabel('mybets.add_to_cart')}</span>
            }
        </>
    );
}

export default ReloadTicketButton;